/* eslint-disable */
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { useEffect, useState } from "react";
import { getEntregaArticulos, invalidateEntregaArticulos } from "../../../project/services/EntregaArticuloService";
import Item from "../../utils/Item";
import WaitingDialog from "../../utils/WaitingDialog";

//
// ###########################################################################
//
const EntregaDetalleDialog = ({ entregaArticulosDetalle, action, onClose, setMessage, setShowMessage }) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [entrega, setEntrega] = useState({});
  const [entregaArticulos, setEntregaArticulos] = useState([]);
  const [entregaEstados, setEntregaEstados] = useState([]);
  const [idGc, setIdGc] = useState(null);
  const [idGcEntrega, setIdGcEntrega] = useState(null);
  const [anularEstado, setAnularEstado] = useState(false);
  const [motivoAnulacion, setMotivoAnulacion] = useState("");
  const navigate = useNavigate();

  const entregaArticulosTableColumns = [
    {
      field: "tipo",
      headerName: "Tipo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion",
      headerName: "Descripción",
      headerAlign: "center",
      flex: 1,
      minWidth: 500,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad_entregada",
      headerName: "Cantidad",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad_entregada;
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const entregaEstadosTableColumns = [
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha de estado",
      flex: 1,
      headerAlign: "center",
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "motivo",
      headerName: "Motivo",
      headerAlign: "center",
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.motivo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "usuarioEstado",
      headerName: "Usuario",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {

    const loadEntrega = async () => {
      setIsDoingSomething(true);
      const response = await getEntregaArticulos(entregaArticulosDetalle.idGcEntrega);
      setIsDoingSomething(false);

      if (response.ok) {

        const _entregaEstados = response.data.data.gc_entrega_estado_list
        const _estadoEntrega = _entregaEstados.find((item) => item.ultimo_estado === true);

        if (action === "delete" && _estadoEntrega.estado === "activo") {
          setIdGc(response.data.data.gc_entrega.id_gc);
          setIdGcEntrega(response.data.data.gc_entrega.id);
          setAnularEstado(true);
        }
        setEntrega(response.data.data.gc_entrega);
        setEntregaArticulos(response.data.data.gc_entrega_item_list);
        setEntregaEstados(_entregaEstados);
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };

    loadEntrega();
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setMotivoAnulacion(e.target.value);
  };
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (!motivoAnulacion || motivoAnulacion.trim() === "") {

      setMessage({
        messageText: "Debes ingresar el motivo de la anulación de la Entrega",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    save();
  };
  //
  // ################################################################################
  //
  const save = async () => {

    const _anulacionEntrega = {
      id: idGcEntrega,
      id_gc: idGc,
      motivo_anulacion: motivoAnulacion,
    };

    setIsDoingSomething(true);
    const response = await invalidateEntregaArticulos(_anulacionEntrega);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    // onClose();
    if (response.ok) {
      setTimeout(() => {
        navigate("/gestion-atencion-table");
      }, 1500);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          handleCloseDialog();
        }}
        disableEscapeKeyDown={false}
        maxWidth="lg"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" sx={{ textAlign: "left" }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Datos de la entrega
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>

          <Grid container spacing={2}>

            <Item label="Retirado por" value={entrega.nombre_cliente ? `${entrega.nombre_cliente ?? ""} ${entrega.apellido_cliente ?? ""}` : "-"} valueColor="info.main" xs={12} sm={6} md={6} lg={6} xl={6} />
            <Item label="Fecha y hora de entrega" value={entrega.fecha_creacion} valueColor="info.main" xs={12} sm={6} md={6} lg={6} xl={6} />
            <Item label="Sucursal de entrega" value={entrega.descripcion_area} xs={12} sm={6} md={6} lg={6} xl={6} />
            <Item label="Entregado por" value={entrega.nombre_usuario ? `${entrega.nombre_usuario ?? ""} ${entrega.apellido_usuario ?? ""}` : " - "} xs={12} sm={6} md={6} lg={6} xl={6} />
            <Item label="Observaciones" value={entrega.observaciones || "Sin observaciones"} xs={12} sm={12} md={12} lg={12} xl={12} />

            <Grid item xs={12}>
              <Box sx={{ mt: 2 }}>
                <Typography variant="body1" >
                  Articulos entregados
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <DataGrid
                rows={entregaArticulos}
                columns={entregaArticulosTableColumns}
                {...tableOptions}
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ mt: 2 }}>
                <Typography variant="body1" >
                  Estados de la entrega
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <DataGrid
                rows={entregaEstados}
                columns={entregaEstadosTableColumns}
                {...tableOptions}
              />
            </Grid>

            {anularEstado && (
              <Grid item xs={12}>
                <TextField
                  sx={{ mt: 1, mb: 1 }}
                  fullWidth
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="motivoAnulacion"
                  label="Motivo de anulación"
                  variant="outlined"
                  size="small"
                  name="motivoAnulacion"
                  value={motivoAnulacion}
                  onChange={handleChange}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogActions>
          <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
            {anularEstado && (
              <Button
                sx={{ backgroundColor: "warning", mr: 1 }}
                className={"btn-add-dialog"}
                variant="contained"
                size="small"
                onClick={handleSave}
                startIcon={<SaveIcon />}
              >
                Anular la entrega
              </Button>
            )}

            <Button
              variant="outlined"
              className="btn-cancel-dialog"
              size="small"
              onClick={handleCloseDialog}
            >
              {anularEstado ? "Cancelar" : "Cerrar"}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default EntregaDetalleDialog;
